import gql from "graphql-tag";

export default gql`
  mutation ToggleBookmarkOnIssuer($issuerId: ObjectID!) {
    toggleBookmarkOnIssuer(issuerId: $issuerId) {
      ... on AmericanCompanyIssuer {
        _id
        viewerDidBookmark
      }
      ... on BrazilianCompanyIssuer {
        _id
        viewerDidBookmark
      }
      ... on BrazilianRealEstateFund {
        _id
        viewerDidBookmark
      }
      ... on BrazilianRealEstateFundIssuer {
        _id
        viewerDidBookmark
      }
    }
  }
`;
